import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { CalAngularService, ICvxClaimsPrincipal } from '@cvx/cal-angular';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: false
})

export class AppComponent implements OnInit, OnDestroy {
  isIframe = false;
  loginDisplay = false;
  cvxClaimsPrincipal: ICvxClaimsPrincipal | null = null;
  
  private readonly _destroying$ = new Subject<void>();  

  constructor(
    private calService: CalAngularService
  ) {}

  showDisclaimer: boolean;
  currentUserId: number;

  ngOnInit(): void {
    this.isIframe = window !== window.parent && !window.opener;

    this.calService.isUserSignedIn()
      .pipe(takeUntil(this._destroying$))
      .subscribe((isSignedIn) => {
        this.loginDisplay = isSignedIn;
        if (isSignedIn) {
          this.cvxClaimsPrincipal = this.calService.cvxClaimsPrincipal;
        }
      });
  }

  setLoginDisplay(): void {
    this.calService.isUserSignedIn().subscribe(isSignedIn => {
      this.loginDisplay = isSignedIn;
    });
  }

  login(): void {
    this.calService.userInitiatedSignIn().subscribe({
      next: (principal) => {
        this.cvxClaimsPrincipal = principal;
        this.loginDisplay = true;
      },
      error: (error) => {
        console.error('Login failed:', error);
      }
    });
  }

  logout(): void {
    this.calService.userInitiatedSignOut().subscribe({
      next: () => {
        this.loginDisplay = false;
        this.cvxClaimsPrincipal = null;
      },
      error: (error) => {
        console.error('Logout failed:', error);
      }
    });
  }
  
  ngOnDestroy(): void {
    this._destroying$.next();
    this._destroying$.complete();
  }  

  iAccept(): void {
    this.loginDisplay = false;
  }
}
